import type { Task } from '@a2a-js/sdk'
import type { A2AChatMessage } from '@/components/chat/lib'

const STORAGE_KEY = 'craft-chat-session'

export interface StoredChatSession {
  contextId: string
  /** Primary anchor — the persistent artifact this chat session belongs to. */
  reportId: string | null
  /** Route hint when the session was saved (e.g. for debugging). */
  runId: string | null
  messagesAndTasks: (A2AChatMessage | Task)[]
}

export function saveChatSession(session: StoredChatSession): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session))
  } catch {
    // quota exceeded or private browsing — silently skip
  }
}

export function getChatSession(): StoredChatSession | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as StoredChatSession
    if (!parsed.contextId || !Array.isArray(parsed.messagesAndTasks) || !('reportId' in parsed))
      return null
    return parsed
  } catch {
    return null
  }
}

export function clearChatSession(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
}
